<template>
  <div class="mx-6 mt-6 mb-8 footer">
    <tx-button
      v-show="showCustom"
      class="mr-5"
      :type="customType" :text="customText" :disabled="customDisabled"
      :loading="customLoading" @click="onCustomClick"
    />
    <tx-button
      :type="secondaryType" :text="secondaryText" :disabled="secondaryDisabled"
      :loading="secondaryLoading" @click="onSecondaryClick"
    />
    <tx-button
      :type="primaryType" :text="primaryText" :disabled="primaryDisabled" class="ml-5"
      :loading="primaryLoading" @click="onPrimaryClick"
    />
  </div>
</template>

<script setup lang='ts'>
import TxButton from '@/shared/components/TxButton.vue'

interface IProps {
  primaryType?: 'confirm' | 'danger' | 'default' | 'cancel' | 'text' | 'icon' | 'nav' | 'plainIcon' | 'staticIcon'
  primaryText?: string
  primaryLoading?: boolean
  primaryDisabled?: boolean
  secondaryType?: 'confirm' | 'danger' | 'default' | 'cancel' | 'text' | 'icon' | 'nav' | 'plainIcon' | 'staticIcon'
  secondaryText?: string
  secondaryLoading?: boolean
  secondaryDisabled?: boolean
  showCustom?: boolean
  customType?: 'confirm' | 'danger' | 'default' | 'cancel' | 'text' | 'icon' | 'nav' | 'plainIcon' | 'staticIcon'
  customText?: string
  customLoading?: boolean
  customDisabled?: boolean
}

withDefaults(defineProps<IProps>(), {
  primaryType: 'confirm',
  primaryText: 'Ok',
  primaryLoading: false,
  primaryDisabled: false,
  secondaryType: 'cancel',
  secondaryText: 'Cancel',
  secondaryLoading: false,
  secondaryDisabled: false,
  showCustom: false,
  customType: 'confirm',
  customText: 'Primary',
  customLoading: false,
  customDisabled: false,

})

const emit = defineEmits(['primaryClick', 'secondaryClick', 'customClick'])

function onPrimaryClick() {
  emit('primaryClick')
}

function onSecondaryClick() {
  emit('secondaryClick')
}

function onCustomClick() {
  emit('customClick')
}
</script>
